import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'

import { Environment } from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  private apiUrl: string = this.verityEnvironmentService.apiUrl + '/v2'

  public getAllEnvironments(): Observable<Array<Environment>> {
    return this.httpClient.get<Environment[]>(`${this.apiUrl}/environment/all`)
  }

  public createEnvironment(
    template: Partial<Environment>,
  ): Observable<Environment> {
    return this.httpClient.post<Environment>(
      `${this.apiUrl}/environment/`,
      template,
    )
  }

  public getEnvironmentById(id: string): Observable<Environment> {
    return this.httpClient.get<Environment>(`${this.apiUrl}/environment/${id}`)
  }

  public updateEnvironment(
    id: string,
    templateData: Partial<Environment>,
  ): Observable<Environment> {
    return this.httpClient.put<Environment>(
      `${this.apiUrl}/environment/${id}`,
      templateData,
    )
  }

  public deleteEnvironment(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/environment/${id}`)
  }
}
